import React, { useState, useContext, useEffect, useRef } from "react";
import "./styles/styles.css";
import "../../styles/global.css";
import { useNavigate } from "react-router-dom";
import { icons, images } from "../../constants";
import { TranslationsContext } from "../../utils/TranslationsContext";
import Languages from "./components/Languages";
import { handleLogout } from "../../utils/methods";

const NavbarSingle = ({ setNavWidth, setLanguage }) => {
  const [isBarOpen, setIsBarOpen] = useState(false);
  const navRef = useRef();
  const [openLanguages, setOpenLanguages] = useState(false);
  const [theme, setTheme] = useState(
    () => localStorage.getItem("theme") || "light",
  );
  const navigate = useNavigate();
  const handleLogoutClick = async () => {
    localStorage.removeItem("single"); // Clear single flag
    await handleLogout();
  };
  const { t } = useContext(TranslationsContext);

  useEffect(() => {
    const updateNavWidth = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth < 1000) {
        setNavWidth(0);
      } else if (navRef.current) {
        requestAnimationFrame(() => {
          setNavWidth(navRef.current.offsetWidth);
        });
      }
    };

    updateNavWidth();
    window.addEventListener("resize", updateNavWidth);

    return () => {
      window.removeEventListener("resize", updateNavWidth);
    };
  }, [setNavWidth]);

  return (
    <div
      className={`flex-direction-column items-center navbar single`}
      ref={navRef}
    >
      <div className="flex-direction-row items-center navbar-logo-hamburger">
        <img src={images.emblemMenu} className="navbar-logo-img" alt="" />
        <div className="flex-direction-row items-center gap-18 language-hamburger">
          <div
            className="navbar-languages-under-999"
            // onClick={() => setOpenLanguages(!openLanguages)}
          >
            <Languages
              openLanguages={openLanguages}
              setIsBarOpen={(value) => setIsBarOpen(value)}
              setLanguageGeneral={setLanguage}
              setOpenLanguages={setOpenLanguages}
              small={true}
            />
          </div>
          <img
            className="hamburger"
            src={isBarOpen ? icons.close : icons.hamburger}
            onClick={() => setIsBarOpen(!isBarOpen)}
            width={30}
            height={30}
            alt="X"
          />
        </div>
      </div>
      <div
        className={`flex-direction-column gap-96 justify-between width-100 height-100 navbar-menu single ${
          isBarOpen ? "open" : ""
        } `}
      >
        <div className="flex-direction-column navbar-links">
          <div
            className="flex-directions-row items-center pointer navbar-link"
            onClick={() => navigate("/")}
          >
            <img
              src={theme == "light" ? icons.calendar : icons.calendar_dark}
              width={24}
              height={24}
              alt="events"
            />
            <p className="inria-sans-300 font-14 weight-700 navbar-term">
              {t("EVENTS_TITLE")}
            </p>
          </div>
        </div>
        <div className="flex-direction-column gap-18  navbar-settings">
          <div className="navbar-languages">
            <Languages
              openLanguages={openLanguages}
              setOpenLanguages={setOpenLanguages}
              setIsBarOpen={(value) => setIsBarOpen(value)}
              setLanguageGeneral={setLanguage}
            />
          </div>
          <div
            className="flex-directions-row items-center pointer navbar-link"
            onClick={handleLogoutClick}
          >
            <img
              src={theme == "light" ? icons.logout : icons.logout_dark}
              width={24}
              height={24}
              alt="X"
            />
            <p className="inria-sans-300 font-14 weight-700 navbar-term">
              {t("LOGOUT")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavbarSingle;
